"use client";
import { Icon as I, Tag as ne, Avatar as se, Colors as ae, iconNames as Ne, Badge as Be } from "@zapier/design-system";
import e, { forwardRef as oe, useState as L, useEffect as S, useRef as P, useCallback as Me, useMemo as Ae } from "react";
import { usePress as Le, useFocusVisible as Se, useTextField as Ee, VisuallyHidden as he } from "react-aria";
import { Tooltip as w } from "@zapier/design-system-beta";
import { Button as H, Link as x, Popover as We, MenuItem as q, Section as re, Separator as ve, MenuTrigger as Pe, Menu as we, Header as le } from "react-aria-components";
import Te from "classnames";
import { emit as $e } from "@zapier/events-toolkit-browser";
const ke = "_builderFrameButton_1ht3z_1", He = "_buttonContent_1ht3z_134", ze = "_buttonText_1ht3z_143", xe = "_buttonIcon_1ht3z_152", K = {
  builderFrameButton: ke,
  buttonContent: He,
  buttonText: ze,
  buttonIcon: xe
}, Fe = (t) => /* @__PURE__ */ e.createElement("span", { className: K.buttonIcon, "data-has-sibling": t.hasSibling }, /* @__PURE__ */ e.createElement(
  I,
  {
    canAcceptPointerEvents: !1,
    isBlock: !0,
    name: t.iconName,
    size: t.size
  }
)), Re = (t) => /* @__PURE__ */ e.createElement("span", { "data-testid": "button-text", className: K.buttonText }, t.children), De = (t) => /* @__PURE__ */ e.createElement("span", { className: K.buttonContent }, t.iconBefore && /* @__PURE__ */ e.createElement(
  Fe,
  {
    hasSibling: !!t.children,
    iconName: t.iconBefore,
    size: 24
  }
), /* @__PURE__ */ e.createElement(Re, null, t.children)), Oe = (t) => t.href && !t.disabled ? x : H;
function ge({
  disabled: t = !1,
  isFullWidth: n = !1,
  isPill: r = !1,
  ...o
}) {
  const a = {
    disabled: t,
    isFullWidth: n,
    isPill: r,
    ...o
  }, s = Oe(a), c = s === x, m = {
    [`${c ? "ariaLabel" : "aria-label"}`]: a["aria-label"]
  };
  return /* @__PURE__ */ e.createElement(
    s,
    {
      "aria-label": a["aria-label"],
      "aria-controls": a["aria-controls"],
      "aria-describedby": a["aria-describedby"],
      "aria-disabled": a.disabled,
      "aria-expanded": a["aria-expanded"],
      "aria-haspopup": a["aria-haspopup"],
      "aria-hidden": a["aria-hidden"],
      ...m,
      color: c ? null : void 0,
      className: K.builderFrameButton,
      "data-color": a.color,
      "data-custom-component": "product-nav-button",
      "data-icon": a.iconBefore ? "before" : void 0,
      "data-full-width": a.isFullWidth ? "" : void 0,
      "data-pill": a.isPill ? "" : void 0,
      "data-selected": a.isSelected ? "" : void 0,
      "data-shadowed": a.hasShadow ? "" : void 0,
      "data-size": a.size,
      "data-square": a.isSquare ? "" : void 0,
      isDisabled: a.disabled,
      href: c ? a.href : void 0,
      id: a.id,
      onPress: a.onPress,
      onKeyDown: a.onKeyDown,
      rel: c ? a.rel : void 0,
      role: c ? void 0 : "button",
      tabIndex: a.tabIndex,
      target: c ? a.target : void 0,
      type: s === H ? a.type : void 0
    },
    /* @__PURE__ */ e.createElement(De, { ...a })
  );
}
function Ba({
  color: t = "primary",
  size: n = "compact",
  ...r
}) {
  return /* @__PURE__ */ e.createElement(ge, { color: t, size: n, ...r });
}
function Ve({
  icon: t,
  iconSize: n,
  isCircle: r,
  label: o,
  ...a
}) {
  return /* @__PURE__ */ e.createElement(w, { content: o || "", offset: 5, placement: "bottom" }, /* @__PURE__ */ e.createElement(
    ge,
    {
      "aria-label": o,
      ...a,
      id: o,
      "aria-describedBy": o,
      isPill: r,
      isSquare: !0
    },
    /* @__PURE__ */ e.createElement(
      I,
      {
        canAcceptPointerEvents: !1,
        isBlock: !0,
        name: t,
        size: 16
      }
    )
  ));
}
function Ue({
  color: t = "icon-primary",
  size: n = "compact",
  tooltipPosition: r = "south",
  ...o
}) {
  return /* @__PURE__ */ e.createElement(
    Ve,
    {
      color: t,
      size: n,
      tooltipPosition: r,
      ...o
    }
  );
}
const Ze = "_genericPopoverBox_1gyev_1", je = {
  genericPopoverBox: Ze
}, Ge = ({
  children: t,
  customPadding: n = "10px 0",
  ...r
}) => /* @__PURE__ */ e.createElement(
  We,
  {
    className: je.genericPopoverBox,
    style: { "--padding": n },
    ...r,
    "data-custom-component": "product-nav-genericPopoverBox"
  },
  t
), qe = "_toolbarButton_1s7j2_1", Ke = "_buttonContent_1s7j2_139", Xe = "_buttonText_1s7j2_151", Ye = "_buttonIcon_1s7j2_169", z = {
  toolbarButton: qe,
  buttonContent: Ke,
  buttonText: Xe,
  buttonIcon: Ye
}, J = (t) => {
  const n = t.iconOnly && typeof t.iconOnly == "object";
  return /* @__PURE__ */ e.createElement(
    "span",
    {
      className: z.buttonIcon,
      "data-has-sibling": t.hasSibling,
      "data-side": t.side
    },
    /* @__PURE__ */ e.createElement(e.Fragment, null, t.iconOnly ? n ? t.iconOnly : /* @__PURE__ */ e.createElement(
      I,
      {
        color: t.iconColor || "inherit",
        isBlock: !0,
        name: t.iconOnly,
        size: t.size,
        shouldAnimateFill: !1
      }
    ) : /* @__PURE__ */ e.createElement(
      I,
      {
        canAcceptPointerEvents: !1,
        color: t.iconColor || "inherit",
        isBlock: !0,
        name: t.iconName,
        size: t.size,
        shouldAnimateFill: !1
      }
    ))
  );
}, Je = (t) => /* @__PURE__ */ e.createElement(
  "span",
  {
    "data-testid": "button-text",
    className: z.buttonText,
    "data-variant": t.variant
  },
  t.children
), ie = (t) => /* @__PURE__ */ e.createElement(e.Fragment, null, t.iconButtonContent ? /* @__PURE__ */ e.createElement("span", { className: z.buttonContent, "data-square": !0 }, /* @__PURE__ */ e.createElement(
  J,
  {
    hasSibling: !1,
    iconOnly: t.iconButtonContent,
    iconName: t.iconButtonContent,
    side: "none",
    size: 16
  }
)) : /* @__PURE__ */ e.createElement("span", { className: z.buttonContent }, t.customBeforeContent || t.iconBefore && /* @__PURE__ */ e.createElement(
  J,
  {
    hasSibling: !!t.children,
    iconName: t.iconBefore,
    iconColor: t.iconColorBefore,
    side: "left",
    size: 16
  }
), /* @__PURE__ */ e.createElement(Je, { variant: t.variant }, t.children), t.customAfterContent && t.customAfterContent, t.iconAfter && /* @__PURE__ */ e.createElement(
  J,
  {
    hasSibling: !!t.children,
    iconColor: t.iconColorAfter,
    iconName: t.iconAfter,
    side: "right",
    size: 14
  }
))), Qe = (t) => t.href && !t.isDisabled ? x : H, X = oe(
  ({ size: t = "xsmall", ...n }, r) => {
    const o = Qe(n), [a, s] = L(!1), [c, m] = L(null);
    S(() => () => {
      c && clearTimeout(c);
    }, [c]);
    const { isPressed: _ } = Le({}), { isFocusVisible: b } = Se(), l = (d) => {
      b && (s(!0), c && clearTimeout(c), m(setTimeout(() => s(!1), 1e3)), n.onFocus && n.onFocus(d));
    }, v = (d) => {
      c && clearTimeout(c), s(!1), n.onBlur && n.onBlur(d);
    }, p = (d) => {
      _ || (s(!0), c && clearTimeout(c), m(setTimeout(() => s(!1), 1e3)), n.onHoverStart && n.onHoverStart(d));
    }, h = (d) => {
      c && clearTimeout(c), s(!1), n.onHoverEnd && n.onHoverEnd(d);
    };
    return n.iconButtonContent ? /* @__PURE__ */ e.createElement(
      w,
      {
        content: n.tooltipContent || "",
        isOpen: a,
        placement: n.tooltipPlacement || "bottom",
        offset: 5
      },
      /* @__PURE__ */ e.createElement(
        o,
        {
          "aria-label": n["aria-label"],
          className: z.toolbarButton,
          "data-custom-component": "product-nav-toolbarbutton",
          "data-size": t,
          href: n.href,
          ref: r,
          isDisabled: n.isDisabled,
          onPress: n.onPress,
          onPressStart: n.onPressStart,
          onPressEnd: n.onPressEnd,
          onPressUp: n.onPressUp,
          onPressChange: n.onPressChange,
          onFocus: l,
          onBlur: v,
          onHoverStart: p,
          onHoverEnd: h,
          onFocusChange: n.onFocusChange,
          onKeyDown: n.onKeyDown,
          onKeyUp: n.onKeyUp,
          target: n.target
        },
        /* @__PURE__ */ e.createElement(ie, { variant: n.variant, ...n })
      )
    ) : /* @__PURE__ */ e.createElement(
      o,
      {
        className: z.toolbarButton,
        "data-custom-component": "product-nav-toolbarbutton",
        "data-size": t,
        href: n.href,
        ref: r,
        isDisabled: n.isDisabled,
        onPress: n.onPress,
        onPressStart: n.onPressStart,
        onPressEnd: n.onPressEnd,
        onPressUp: n.onPressUp,
        onPressChange: n.onPressChange,
        onFocus: n.onFocus,
        onBlur: n.onBlur,
        onFocusChange: n.onFocusChange,
        onKeyDown: n.onKeyDown,
        onKeyUp: n.onKeyUp,
        target: n.target
      },
      /* @__PURE__ */ e.createElement(ie, { variant: n.variant, ...n })
    );
  }
);
X.displayName = "ToolbarButton";
const et = "_dropdownMenu_4zi4s_1", tt = {
  dropdownMenu: et
}, nt = "_dropdownMenuItem_w7r6l_1", at = {
  dropdownMenuItem: nt
}, rt = ({
  variant: t = "default",
  ...n
}) => /* @__PURE__ */ e.createElement(
  q,
  {
    className: at.dropdownMenuItem,
    value: n.value,
    "data-variant": t,
    ...n
  }
), ot = "_dropdownMenuSection_nlvhc_1", ct = {
  dropdownMenuSection: ot
}, st = ({
  children: t,
  label: n
}) => /* @__PURE__ */ e.createElement(re, { className: ct.dropdownMenuSection, "aria-label": n }, t), lt = "_dropdownMenuSeparator_1yuu3_1", it = {
  dropdownMenuSeparator: lt
}, ut = () => /* @__PURE__ */ e.createElement(ve, { className: it.dropdownMenuSeparator }), mt = e.forwardRef(
  ({
    label: t,
    children: n,
    customAfterContent: r,
    customBeforeContent: o,
    customPopoverPadding: a,
    disabledKeys: s = [],
    footer: c,
    iconAfter: m,
    iconBefore: _,
    iconButtonContent: b,
    iconColorAfter: l,
    iconColorBefore: v,
    isKebabMenu: p = !1,
    placement: h,
    size: d,
    variant: E = "default",
    ...g
  }, W) => /* @__PURE__ */ e.createElement(Pe, { ...g, "data-custom-component": "product-nav-DropdownMenu" }, p ? /* @__PURE__ */ e.createElement(
    Ue,
    {
      icon: "navMoreVert",
      "aria-label": t
    }
  ) : /* @__PURE__ */ e.createElement(
    X,
    {
      "aria-label": t,
      customAfterContent: r,
      customBeforeContent: o,
      iconAfter: m,
      iconBefore: _,
      iconButtonContent: b,
      iconColorAfter: l,
      iconColorBefore: v,
      isDisabled: g.isDisabled,
      ref: W,
      tooltipContent: g.tooltipContent,
      tooltipPlacement: g.tooltipPlacement,
      variant: E,
      size: d
    },
    t
  ), /* @__PURE__ */ e.createElement(
    Ge,
    {
      placement: h,
      "data-padding": E,
      customPadding: a,
      offset: p ? 17 : 8
    },
    /* @__PURE__ */ e.createElement(
      we,
      {
        ...g,
        disabledKeys: s,
        className: tt.dropdownMenu,
        "data-orientation": E === "default" || E === "product-menu" ? "vertical" : "horizontal"
      },
      n
    ),
    c && c
  ))
), N = mt;
N.Item = rt;
N.Section = st;
N.Separator = ut;
const dt = "_assetControlAvatar_1o39k_1", pt = "_assetControlPermissionsTagLabel_1o39k_8", _t = "_assetControlTagLabel_1o39k_11", ft = "_assetControlWrapper_1o39k_14", F = {
  assetControlAvatar: dt,
  assetControlPermissionsTagLabel: pt,
  assetControlTagLabel: _t,
  assetControlWrapper: ft
}, bt = "_form_5nzqe_1", Et = "_input_5nzqe_19", ue = {
  form: bt,
  input: Et
}, ht = oe((t, n) => {
  var m;
  const { label: r } = t, o = P(null), a = P(null);
  S(() => {
    typeof n == "function" ? n(o.current) : n && (n.current = o.current);
  }, [n]), S(() => {
    a.current && o.current && a.current.setAttribute("data-value", o.current.value);
  }, [(m = o.current) == null ? void 0 : m.value]);
  const { labelProps: s, inputProps: c } = Ee(t, o);
  return /* @__PURE__ */ e.createElement("form", { onSubmit: t.onSubmit, className: ue.form, ref: a }, /* @__PURE__ */ e.createElement(he, null, /* @__PURE__ */ e.createElement("label", { ...s, htmlFor: "asset-rename" }, r)), /* @__PURE__ */ e.createElement(
    "input",
    {
      ...c,
      ref: o,
      className: ue.input,
      id: "asset-rename",
      name: "asset-rename",
      maxLength: t.maxLength
    }
  ));
}), vt = "_assetParentLink_8cdx2_1", gt = "_assetParentLinkWrapper_8cdx2_10", Ct = "_assetParentLinkTextWrapper_8cdx2_39", Q = {
  assetParentLink: vt,
  assetParentLinkWrapper: gt,
  assetParentLinkTextWrapper: Ct
}, It = ({
  icon: t = "navFolder",
  ...n
}) => /* @__PURE__ */ e.createElement(
  x,
  {
    className: Q.assetParentLink,
    href: n.href,
    isDisabled: n.isDisabled,
    "data-custom-component": "product-nav-AssetParentLink",
    "data-testid": "product-nav-AssetParentLink"
  },
  /* @__PURE__ */ e.createElement("span", { className: Q.assetParentLinkWrapper }, t && /* @__PURE__ */ e.createElement(
    I,
    {
      name: t,
      size: 16,
      shouldAnimateFill: !1,
      color: "inherit"
    }
  ), /* @__PURE__ */ e.createElement("span", { className: Q.assetParentLinkTextWrapper }, n.children))
), me = (t) => t.id !== void 0, Ma = ({
  disabledKeys: t = [],
  maxLength: n = 255,
  menuItems: r = [],
  onRename: o,
  owner: a,
  parentHref: s,
  parentText: c,
  parentIcon: m,
  permissions: _ = "edit",
  tagLabel: b,
  ...l
}) => {
  const { label: v, ...p } = l, [h, d] = L(!1), [E, g] = L(l.label), W = P(null), $ = P(null), [i, f] = L(E);
  S(() => {
    g(l.label), f(l.label);
  }, [l.label]);
  const M = () => {
    d(!0), setTimeout(() => {
      var u, C;
      (u = W.current) == null || u.focus(), (C = W.current) == null || C.select();
    }, 0);
  }, y = (u) => {
    u.trim() === "" || u.trim() === i ? g(l.label) : (g(u), o && o(u)), d(!1), setTimeout(() => {
      var C;
      (C = $.current) == null || C.focus();
    }, 0);
  }, V = {
    rename: M,
    ...r.reduce((u, C) => me(C) ? { ...u, [C.id]: C.action } : u, {})
  }, Y = (u) => {
    const C = V[u];
    C && C();
  };
  return _ === "view" ? /* @__PURE__ */ e.createElement(
    X,
    {
      isDisabled: !0,
      customBeforeContent: a != null && a.name ? /* @__PURE__ */ e.createElement("div", { className: F.assetControlAvatar }, /* @__PURE__ */ e.createElement(
        se,
        {
          color: "tertiary",
          name: a.name,
          url: a.avatarUrl,
          size: "small"
        }
      )) : null,
      customAfterContent: /* @__PURE__ */ e.createElement("div", { className: F.assetControlPermissionsTagLabel }, /* @__PURE__ */ e.createElement(ne, { size: "x-small" }, "View only")),
      size: "small"
    },
    l.label
  ) : /* @__PURE__ */ e.createElement(e.Fragment, null, h ? /* @__PURE__ */ e.createElement(
    ht,
    {
      type: "text",
      label: "Asset Name",
      maxLength: n,
      ref: W,
      value: E,
      onBlur: (u) => y(u.target.value),
      onChange: (u) => g(u),
      onSubmit: () => y(E)
    }
  ) : /* @__PURE__ */ e.createElement("div", { className: F.assetControlWrapper }, s && c && /* @__PURE__ */ e.createElement(It, { href: s, icon: m }, c), /* @__PURE__ */ e.createElement(
    N,
    {
      ref: $,
      label: E,
      onAction: Y,
      disabledKeys: t,
      customBeforeContent: a != null && a.name ? /* @__PURE__ */ e.createElement("div", { className: F.assetControlAvatar }, /* @__PURE__ */ e.createElement(
        se,
        {
          color: "tertiary",
          name: a.name,
          url: a.avatarUrl
        }
      )) : null,
      customAfterContent: b ? /* @__PURE__ */ e.createElement("div", { className: F.assetControlTagLabel }, /* @__PURE__ */ e.createElement(ne, { size: "x-small" }, b)) : null,
      iconAfter: _ === "edit" ? "arrowSmallDown" : void 0,
      placement: "bottom",
      size: "small",
      ...p
    },
    o && /* @__PURE__ */ e.createElement(N.Item, { id: "rename", key: "rename" }, "Rename"),
    r.map(
      (u, C) => e.isValidElement(u) ? e.cloneElement(u, { key: C }) : me(u) ? /* @__PURE__ */ e.createElement(
        N.Item,
        {
          id: u.id,
          key: u.id,
          href: u.href,
          variant: u.variant
        },
        u.label
      ) : null
    )
  )));
}, yt = "_usersBarWrapper_iyvrd_1", Nt = "_otherUserWrapper_iyvrd_8", Bt = "_userItemWrapper_iyvrd_16", Mt = "_userItemNumberWrapper_iyvrd_17", At = "_userItemAvatarWrapper_iyvrd_22", Lt = "_userItemAvatarImage_iyvrd_42", St = "_initialContainer_iyvrd_47", Wt = "_plusItem_iyvrd_59", Pt = "_plusItemText_iyvrd_69", B = {
  usersBarWrapper: yt,
  otherUserWrapper: Nt,
  userItemWrapper: Bt,
  userItemNumberWrapper: Mt,
  userItemAvatarWrapper: At,
  userItemAvatarImage: Lt,
  initialContainer: St,
  plusItem: Wt,
  plusItemText: Pt
}, wt = ({
  numOfHiddenUsers: t
}) => {
  const n = t > 99;
  return /* @__PURE__ */ e.createElement(
    w,
    {
      content: `+${t} more`,
      offset: "large",
      placement: "bottom"
    },
    /* @__PURE__ */ e.createElement(H, { key: "additional", className: B.otherUserWrapper }, /* @__PURE__ */ e.createElement("div", { className: B.userItemNumberWrapper, "data-testid": "plus-item" }, /* @__PURE__ */ e.createElement(
      "div",
      {
        className: Te(B.userItemAvatarWrapper, {
          [B.plusItem]: !0
        })
      },
      /* @__PURE__ */ e.createElement("div", { className: B.plusItemText }, n ? /* @__PURE__ */ e.createElement(I, { name: "formAdd", size: 20 }) : `+${t}`)
    )))
  );
}, Aa = ({ users: t = [], max: n = 3 }) => {
  const r = t.slice(0, n), o = t.length - r.length;
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: B.avatarStack,
      "data-custom-component": "product-nav-AvatarStack",
      "data-testid": "avatar-stack"
    },
    /* @__PURE__ */ e.createElement("div", { className: B.usersBarWrapper }, r.map((a) => /* @__PURE__ */ e.createElement(
      Tt,
      {
        key: String(a.id),
        name: a.name,
        photoUrl: a.photoUrl,
        color: a.color
      }
    )), o > 0 && /* @__PURE__ */ e.createElement(wt, { numOfHiddenUsers: o }))
  );
}, Tt = ({ name: t, photoUrl: n, color: r }) => /* @__PURE__ */ e.createElement(w, { content: t || "", placement: "bottom", offset: "large" }, /* @__PURE__ */ e.createElement(H, { className: B.otherUserWrapper }, /* @__PURE__ */ e.createElement("div", { className: B.userItemWrapper }, /* @__PURE__ */ e.createElement(
  "div",
  {
    className: B.userItemAvatarWrapper,
    style: {
      border: `2px solid ${r}`
    }
  },
  n ? /* @__PURE__ */ e.createElement(
    "img",
    {
      src: n,
      alt: t,
      className: B.userItemAvatarImage
    }
  ) : /* @__PURE__ */ e.createElement("div", { className: B.initialContainer }, t == null ? void 0 : t.substring(0, 1))
)))), $t = "_builderFrameLayout_11o7v_1", kt = "_header_11o7v_11", Ht = "_sidebar_11o7v_18", zt = "_mainContent_11o7v_25", U = {
  builderFrameLayout: $t,
  header: kt,
  sidebar: Ht,
  mainContent: zt
}, La = ({
  header: t,
  sidebar: n,
  drawer: r,
  mainContent: o,
  mainOverrideStyles: a = {}
}) => /* @__PURE__ */ e.createElement(
  "div",
  {
    className: U.builderFrameLayout,
    "data-custom-component": "product-nav-BuilderFrameLayout"
  },
  /* @__PURE__ */ e.createElement("div", { className: U.header }, t),
  /* @__PURE__ */ e.createElement("div", { className: U.sidebar }, n, r),
  /* @__PURE__ */ e.createElement(
    "div",
    {
      className: U.mainContent,
      style: a
    },
    o
  )
), xt = "_root_1ule9_1", Ft = "_drawer_1ule9_7", Rt = "_header_1ule9_25", Dt = "_titleWrapper_1ule9_33", Ot = "_buttonWrapper_1ule9_41", Vt = "_content_1ule9_60", Ut = "_contentHeader_1ule9_73", T = {
  root: xt,
  drawer: Ft,
  header: Rt,
  titleWrapper: Dt,
  buttonWrapper: Ot,
  content: Vt,
  contentHeader: Ut
}, Sa = ({
  children: t,
  hasSidePadding: n = !0,
  header: r,
  isFixed: o = !1,
  isOpen: a,
  isResponsive: s = !1,
  onClose: c,
  title: m,
  ..._
}) => {
  const [b, l] = L(a), v = P(null), p = P(null);
  S(() => {
    l(a);
  }, [a]);
  const h = Me(() => {
    c();
  }, [c]);
  return S(() => {
    const d = (E) => {
      E.key === "Escape" && h();
    };
    return window.document.addEventListener("keydown", d, !1), () => {
      window.document.removeEventListener("keydown", d, !1);
    };
  }, [h]), S(() => {
    const d = (E) => {
      p.current && !p.current.contains(E.target) && h();
    };
    return _.closeOnOutsideClick && document.addEventListener("mousedown", d), () => {
      document.removeEventListener("mousedown", d);
    };
  }, [h, _.closeOnOutsideClick, p]), /* @__PURE__ */ e.createElement(
    "div",
    {
      "data-testid": "BuilderFrameDrawer",
      className: T.root,
      ref: p,
      ..._,
      "data-custom-component": "product-nav-drawer"
    },
    b ? /* @__PURE__ */ e.createElement(
      "section",
      {
        className: T.drawer,
        "data-responsive": s,
        style: {
          "--box-shadow": o ? "none" : "0px 5px 10px 0px rgba(0, 0, 0, 0.10);",
          "--position": o ? "relative" : "absolute"
        }
      },
      /* @__PURE__ */ e.createElement("div", { className: T.headerWrapper }, /* @__PURE__ */ e.createElement("div", { className: T.header }, m ? /* @__PURE__ */ e.createElement("div", { className: T.titleWrapper, ref: v }, m) : null, /* @__PURE__ */ e.createElement(
        H,
        {
          className: T.buttonWrapper,
          onPress: h,
          "aria-label": "Close Sidebar Button"
        },
        /* @__PURE__ */ e.createElement(
          I,
          {
            "aria-label": "Close Sidebar",
            shouldAnimateFill: !1,
            name: "formX",
            color: "inherit",
            size: 20
          }
        )
      )), r && /* @__PURE__ */ e.createElement("div", { "data-testid": "header", className: T.contentHeader }, r)),
      /* @__PURE__ */ e.createElement("div", { className: T.content, "data-padding": n }, t)
    ) : null
  );
}, Zt = "_grid_1lewt_1", jt = {
  grid: Zt
}, Gt = (t) => `minmax(${t}, auto)`, de = (t) => typeof t == "number" ? `repeat(${t}, 1fr)` : t, qt = (t) => t.map((n) => `"${n}"`).join(" "), Kt = ({
  alignContent: t,
  alignItems: n,
  areas: r,
  children: o,
  columnGap: a,
  columns: s = 4,
  flow: c,
  gap: m,
  height: _,
  justifyContent: b,
  justifyItems: l,
  minRowHeight: v,
  overrideStyles: p,
  rowGap: h,
  rows: d,
  width: E
}) => {
  const g = {
    alignContent: t,
    alignItems: n,
    gridTemplateAreas: r && qt(r),
    columnGap: a,
    rowGap: h,
    gridTemplateColumns: de(s),
    gridAutoFlow: c || "row",
    gap: m,
    height: _ || "auto",
    justifyContent: b,
    justifyItems: l,
    gridAutoRows: v && Gt(v),
    gridTemplateRows: d && de(d),
    width: E || "100%"
  };
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: jt.grid,
      style: { ...g, ...p },
      "data-custom-component": "product-nav-Grid",
      "data-testid": "product-nav-Grid"
    },
    o
  );
};
Kt.displayName = "Grid";
const Xt = "_gridItem_12a5j_1", Yt = {
  gridItem: Xt
}, Wa = e.forwardRef(
  ({
    alignSelf: t,
    area: n,
    center: r,
    children: o,
    colWidth: a = 1,
    left: s,
    middle: c,
    overrideStyles: m = {},
    rowHeight: _ = 1,
    top: b
  }, l) => {
    const v = {
      gridColumnEnd: `span ${a}`,
      gridRowEnd: `span ${_}`,
      alignSelf: t,
      gridColumnStart: s,
      gridRowStart: b,
      gridArea: n,
      display: c ? "inline-flex" : "unset",
      flexFlow: c ? "column wrap" : "unset",
      justifyContent: c ? "center" : "unset",
      justifySelf: c ? "stretch" : "unset",
      textAlign: r ? "center" : "unset"
    };
    return /* @__PURE__ */ e.createElement(
      "div",
      {
        className: Yt.gridItem,
        style: { ...v, ...m },
        ref: l
      },
      o
    );
  }
), Jt = "_root_1clau_1", Qt = "_header_1clau_5", en = "_headerLeftCorner_1clau_14", tn = "_headerRightCorner_1clau_36", Z = {
  root: Jt,
  header: Qt,
  headerLeftCorner: en,
  headerRightCorner: tn
}, Pa = ({
  backgroundColor: t = ae.GrayWarm9,
  children: n,
  height: r = "44px",
  isResponsive: o = !1
}) => /* @__PURE__ */ e.createElement("div", { className: Z.root }, /* @__PURE__ */ e.createElement(
  "header",
  {
    className: Z.header,
    style: {
      "--height": r,
      "--backgroundColor": t
    },
    "data-custom-component": "product-nav-header"
  },
  n
), /* @__PURE__ */ e.createElement(
  "div",
  {
    className: Z.headerLeftCorner,
    "data-responsive": o,
    style: {
      "--backgroundColor": t
    }
  }
), /* @__PURE__ */ e.createElement(
  "div",
  {
    className: Z.headerRightCorner,
    "data-responsive": o,
    style: {
      "--backgroundColor": t
    }
  }
)), nn = "_headerLayout_19oi0_1", an = "_headerLayoutComponent_19oi0_6", rn = "_headerLayoutComponentCenter_19oi0_11", on = "_headerLayoutLeft_19oi0_14", cn = "_headerLayoutCenter_19oi0_21", sn = "_headerLayoutRight_19oi0_38", ln = "_tabletHidden_19oi0_48", un = "_tabletShown_19oi0_51", mn = "_mobileShown_19oi0_65", dn = "_mobileHidden_19oi0_71", A = {
  headerLayout: nn,
  headerLayoutComponent: an,
  headerLayoutComponentCenter: rn,
  headerLayoutLeft: on,
  headerLayoutCenter: cn,
  headerLayoutRight: sn,
  tabletHidden: ln,
  tabletShown: un,
  mobileShown: mn,
  mobileHidden: dn
}, ee = (t, n) => t.map(
  ({ component: r, hideOnMobile: o, hideOnTablet: a, showOnTablet: s, showOnMobile: c }, m) => {
    if (!r)
      return null;
    const _ = [
      A.headerLayoutComponent,
      n ? A.headerLayoutComponentCenter : null,
      o ? A.mobileHidden : null,
      a ? A.tabletHidden : null,
      c ? A.mobileShown : null,
      s ? A.tabletShown : null
    ];
    return /* @__PURE__ */ e.createElement("div", { key: m, className: _.join(" ").trim() }, e.cloneElement(r));
  }
), wa = ({
  leftColumnComponents: t = [],
  centerColumnComponents: n = [],
  rightColumnComponents: r = []
}) => /* @__PURE__ */ e.createElement("div", { className: A.headerLayout }, t.length > 0 && /* @__PURE__ */ e.createElement("div", { className: A.headerLayoutLeft }, ee(t)), n.length > 0 && /* @__PURE__ */ e.createElement("div", { className: A.headerLayoutCenter }, ee(n, !0)), r.length > 0 && /* @__PURE__ */ e.createElement("div", { className: A.headerLayoutRight }, ee(r))), pn = "_iconMenuItemContent_uadb5_1", _n = "_iconList_uadb5_7", fn = "_iconWrapper_uadb5_16", bn = "_iconTextWrapper_uadb5_17", En = "_fancyIconWrapper_uadb5_34", O = {
  iconMenuItemContent: pn,
  iconList: _n,
  iconWrapper: fn,
  iconTextWrapper: bn,
  fancyIconWrapper: En
}, hn = ({
  textValue: t,
  icons: n
}) => /* @__PURE__ */ e.createElement(
  "div",
  {
    className: O.iconMenuItemContent,
    "data-custom-component": "product-nav-IconMenuItemContent"
  },
  /* @__PURE__ */ e.createElement("span", null, t),
  n && n.length > 0 && /* @__PURE__ */ e.createElement("ul", { className: O.iconList }, n.map((r) => /* @__PURE__ */ e.createElement("li", { key: r, className: O.fancyIconWrapper }, /* @__PURE__ */ e.createElement(gn, { icon: r }))))
), vn = Object.keys(Ne), gn = ({ icon: t }) => vn.includes(t) ? /* @__PURE__ */ e.createElement("span", { className: O.iconWrapper }, /* @__PURE__ */ e.createElement(
  I,
  {
    color: "inherit",
    name: t,
    size: 11,
    shouldAnimateFill: !1
  }
)) : /* @__PURE__ */ e.createElement("span", { className: O.iconTextWrapper }, t), Cn = "_productHubIconWrapper_1wa98_8", In = "_productMenuHeader_1wa98_18", yn = "_productMenuSeparator_1wa98_30", Nn = "_productMenuSection_1wa98_36", Bn = "_mainSection_1wa98_40", k = {
  productHubIconWrapper: Cn,
  productMenuHeader: In,
  productMenuSeparator: yn,
  productMenuSection: Nn,
  mainSection: Bn
}, Mn = "_productMenuItem_l00io_1", An = "_productMenuItemIconWrapper_l00io_58", Ln = "_productMenuItemLabelWrapper_l00io_62", Sn = "_productMenuItemCreateButton_l00io_70", R = {
  productMenuItem: Mn,
  productMenuItemIconWrapper: An,
  productMenuItemLabelWrapper: Ln,
  productMenuItemCreateButton: Sn
}, Wn = "_productMenuTag_1mqy8_1", Pn = {
  productMenuTag: Wn
}, ce = ({ tag: t }) => /* @__PURE__ */ e.createElement(ne, { className: Pn.productMenuTag, variant: "simple", size: "x-small" }, t), wn = ({
  variant: t = "product-menu",
  ...n
}) => {
  const { iconAfter: r } = n;
  return /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    q,
    {
      className: R.productMenuItem,
      href: n.href,
      "data-variant": t,
      ...n
    },
    /* @__PURE__ */ e.createElement("span", { className: R.productMenuItemIconWrapper }, /* @__PURE__ */ e.createElement(
      I,
      {
        color: "BrandOrange",
        name: n.icon,
        size: 18,
        shouldAnimateFill: !1
      }
    )),
    /* @__PURE__ */ e.createElement("div", { className: R.productMenuItemLabelWrapper }, n.label, n.tag && /* @__PURE__ */ e.createElement(ce, { tag: n.tag }))
  ), n.iconAfter && /* @__PURE__ */ e.createElement(
    q,
    {
      className: R.productMenuItem,
      href: n.createHref,
      "data-variant": t,
      id: n.label
    },
    ({ isFocusVisible: o, isHovered: a }) => /* @__PURE__ */ e.createElement(
      w,
      {
        content: `Create ${n.label === "Canvas" ? n.label : n.label.slice(0, -1)}`,
        offset: 27,
        placement: "right",
        isOpen: o || a
      },
      /* @__PURE__ */ e.createElement(
        w.FocusableTrigger,
        {
          className: R.productMenuItemCreateButton
        },
        /* @__PURE__ */ e.createElement(
          I,
          {
            color: o || a ? "PrimeWhite" : "GrayWarm5",
            name: r,
            shouldAnimateFill: !1,
            size: 18
          }
        )
      )
    )
  ));
}, Tn = "_productHubFooter_11pdk_1", $n = {
  productHubFooter: Tn
}, kn = ({
  children: t,
  style: n
}) => /* @__PURE__ */ e.createElement("footer", { className: $n.productHubFooter, style: n }, t), Hn = "_root_1bkvj_1", zn = {
  root: Hn
}, xn = () => /* @__PURE__ */ e.createElement(
  "svg",
  {
    className: zn.root,
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 4C3 3.44772 3.44772 3 4 3H6C6.55228 3 7 3.44772 7 4V6C7 6.55228 6.55228 7 6 7H4C3.44772 7 3 6.55228 3 6V4ZM10 4C10 3.44772 10.4477 3 11 3H13C13.5523 3 14 3.44772 14 4V6C14 6.55228 13.5523 7 13 7H11C10.4477 7 10 6.55228 10 6V4ZM18 3C17.4477 3 17 3.44772 17 4V6C17 6.55228 17.4477 7 18 7H20C20.5523 7 21 6.55228 21 6V4C21 3.44772 20.5523 3 20 3H18ZM3 11C3 10.4477 3.44772 10 4 10H6C6.55228 10 7 10.4477 7 11V13C7 13.5523 6.55228 14 6 14H4C3.44772 14 3 13.5523 3 13V11ZM11 10C10.4477 10 10 10.4477 10 11V13C10 13.5523 10.4477 14 11 14H13C13.5523 14 14 13.5523 14 13V11C14 10.4477 13.5523 10 13 10H11ZM17 11C17 10.4477 17.4477 10 18 10H20C20.5523 10 21 10.4477 21 11V13C21 13.5523 20.5523 14 20 14H18C17.4477 14 17 13.5523 17 13V11ZM4 17C3.44772 17 3 17.4477 3 18V20C3 20.5523 3.44772 21 4 21H6C6.55228 21 7 20.5523 7 20V18C7 17.4477 6.55228 17 6 17H4ZM10 18C10 17.4477 10.4477 17 11 17H13C13.5523 17 14 17.4477 14 18V20C14 20.5523 13.5523 21 13 21H11C10.4477 21 10 20.5523 10 20V18ZM18 17C17.4477 17 17 17.4477 17 18V20C17 20.5523 17.4477 21 18 21H20C20.5523 21 21 20.5523 21 20V18C21 17.4477 20.5523 17 20 17H18Z"
    }
  )
), Fn = "_productMenuItem_15wyi_1", Rn = "_productMenuItemIconWrapper_15wyi_55", Dn = "_productMenuItemLabelWrapper_15wyi_59", On = "_productMenuItemIconAfterWrapper_15wyi_67", j = {
  productMenuItem: Fn,
  productMenuItemIconWrapper: Rn,
  productMenuItemLabelWrapper: Dn,
  productMenuItemIconAfterWrapper: On
}, Ce = ({
  variant: t = "product-menu",
  ...n
}) => /* @__PURE__ */ e.createElement(
  q,
  {
    className: j.productMenuItem,
    href: n.href,
    "data-variant": t,
    ...n
  },
  /* @__PURE__ */ e.createElement("span", { className: j.productMenuItemIconWrapper }, /* @__PURE__ */ e.createElement(
    I,
    {
      color: "BrandOrange",
      name: n.icon,
      size: 18,
      shouldAnimateFill: !1
    }
  )),
  /* @__PURE__ */ e.createElement("div", { className: j.productMenuItemLabelWrapper }, n.label, n.tag && /* @__PURE__ */ e.createElement(ce, { tag: n.tag }), n.iconAfter && /* @__PURE__ */ e.createElement(w, { content: "Upgrade required", offset: 5, placement: "top" }, /* @__PURE__ */ e.createElement(
    w.FocusableTrigger,
    {
      className: j.productMenuItemIconAfterWrapper
    },
    /* @__PURE__ */ e.createElement(I, { color: "GrayWarm6", name: n.iconAfter, size: 16 })
  )))
), Vn = "web_analytics.tracking.user_interaction.UserInteractionEvent", Un = async ({
  interaction_name: t = "call_to_action",
  system_name: n = "design_system",
  ...r
}) => await $e(
  {
    ...r,
    absolute_url: window.location.pathname,
    interaction_name: t,
    referrer: document.referrer,
    system_name: n
  },
  Vn
), Ie = [
  {
    createHref: `https://${process.env.ZAPIER_DOMAIN || "zapier"}.com/webintent/create-zap?entry-point-method=make_a_zap_call_to_action`,
    ownCreateHref: "/webintent/create-zap?entry-point-method=make_a_zap_call_to_action",
    label: "Zaps",
    icon: "miscBoltAltFill",
    href: `https://${process.env.ZAPIER_DOMAIN || "zapier"}.com/app/zaps`,
    target: "_blank",
    iconAfter: "formAdd"
  },
  {
    createHref: `https://tables.${process.env.ZAPIER_DOMAIN || "zapier"}.com/app/tables?modalOpen=create`,
    ownCreateHref: "/app/tables?modalOpen=create",
    label: "Tables",
    icon: "navTables",
    href: `https://tables.${process.env.ZAPIER_DOMAIN || "zapier"}.com`,
    target: "_blank",
    iconAfter: "formAdd"
  },
  {
    createHref: `https://interfaces.${process.env.ZAPIER_DOMAIN || "zapier"}.com/interfaces?modalOpen=create`,
    ownCreateHref: "/interfaces?modalOpen=create",
    label: "Interfaces",
    icon: "navInterfaces",
    href: `https://interfaces.${process.env.ZAPIER_DOMAIN || "zapier"}.com`,
    target: "_blank",
    iconAfter: "formAdd"
  },
  {
    createHref: `https://${process.env.ZAPIER_DOMAIN || "zapier"}.com/app/chatbots?modalOpen=create`,
    ownCreateHref: "/app/chatbots?modalOpen=create",
    label: "Chatbots",
    icon: "navAIChatbot",
    href: `https://${process.env.ZAPIER_DOMAIN || "zapier"}.com/app/chatbots`,
    target: "_blank",
    tag: "BETA",
    iconAfter: "formAdd"
  },
  {
    createHref: `https://${process.env.ZAPIER_DOMAIN || "zapier"}.com/app/canvas/new`,
    ownCreateHref: "/app/canvas/new",
    label: "Canvas",
    icon: "navCanvas",
    href: `https://${process.env.ZAPIER_DOMAIN || "zapier"}.com/app/canvas`,
    tag: "BETA",
    target: "_blank",
    iconAfter: "formAdd"
  }
], Zn = [], jn = ({
  features: t = Zn,
  footer: n,
  iconAfter: r,
  iconButtonContent: o,
  productIcon: a,
  productName: s,
  tooltipContent: c = "Automation products",
  userAccess: m = [],
  variant: _ = "inline-product-menu",
  ...b
}) => /* @__PURE__ */ e.createElement(
  N,
  {
    "data-custom-component": "product-nav-ProductHub",
    iconButtonContent: /* @__PURE__ */ e.createElement("div", { className: k.productHubIconWrapper }, /* @__PURE__ */ e.createElement(xn, null)),
    label: c,
    customPopoverPadding: "15px 0 0 0",
    footer: n ? /* @__PURE__ */ e.createElement(
      kn,
      {
        style: {
          width: t.length > 0 ? "auto" : "300px"
        }
      },
      n
    ) : null,
    onAction: (l) => {
      Un({
        event_action: "click",
        option_selected: `BuilderFrame ProductHub selection ${l}`,
        system_name: s
      });
    },
    placement: "bottom left",
    tooltipContent: c,
    tooltipPlacement: "bottom left",
    variant: _,
    ...b
  },
  /* @__PURE__ */ e.createElement(re, { className: `${k.productMenuSection} ${k.mainSection}` }, /* @__PURE__ */ e.createElement(le, { className: k.productMenuHeader }, /* @__PURE__ */ e.createElement("span", null, "Zapier Automation Platform")), Ie.map((l) => /* @__PURE__ */ e.createElement(
    wn,
    {
      key: l.label,
      href: `${l.href}?utm_source=${s}&utm_medium=builder-frame`,
      icon: l.icon,
      iconAfter: l.iconAfter,
      label: l.label,
      createHref: l.label === s ? l.ownCreateHref : l.createHref,
      tag: l.tag,
      variant: "inline-product-menu"
    }
  ))),
  t.length > 0 && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    ve,
    {
      className: k.productMenuSeparator,
      orientation: "horizontal"
    }
  ), /* @__PURE__ */ e.createElement(re, { className: k.productMenuSection }, /* @__PURE__ */ e.createElement(le, { className: k.productMenuHeader }, "Also try"), t.map((l) => /* @__PURE__ */ e.createElement(
    Ce,
    {
      key: l.label,
      href: `${l.href}?utm_source=${s}&utm_medium=builder-frame`,
      icon: l.icon,
      iconAfter: m.includes(l.label) ? void 0 : l.iconAfter,
      label: l.label,
      tag: l.tag,
      variant: "inline-product-menu"
    }
  ))))
);
jn.Item = Ce;
const Gn = "_productListButtonIconWrapper_1p27v_1", qn = "_productListButtonLabelWrapper_1p27v_5", pe = {
  productListButtonIconWrapper: Gn,
  productListButtonLabelWrapper: qn
}, Ta = ({
  productListHref: t,
  productListTarget: n = "_self",
  productName: r,
  ...o
}) => {
  const a = Ae(
    () => Ie.find((s) => s.label === r),
    [r]
  );
  return /* @__PURE__ */ e.createElement(
    X,
    {
      customBeforeContent: /* @__PURE__ */ e.createElement("div", { className: pe.productListButtonIconWrapper }, /* @__PURE__ */ e.createElement(I, { color: "BrandOrange", name: a == null ? void 0 : a.icon, size: 18 })),
      href: t || (a == null ? void 0 : a.href),
      target: n || (a == null ? void 0 : a.target),
      variant: "product-menu",
      ...o
    },
    /* @__PURE__ */ e.createElement("h1", { className: pe.productListButtonLabelWrapper }, r, (a == null ? void 0 : a.tag) && /* @__PURE__ */ e.createElement(ce, { tag: a.tag }))
  );
}, Kn = "_sideBarItem_1mrxv_1", Xn = "_buttonStyles_1mrxv_8", Yn = "_badgeStyles_1mrxv_44", Jn = "_statusIconStyles_1mrxv_45", G = {
  sideBarItem: Kn,
  buttonStyles: Xn,
  badgeStyles: Yn,
  statusIconStyles: Jn
}, _e = (t) => {
  switch (t) {
    case "error":
      return { color: "StatusError", icon: "formX" };
    case "warning":
      return { color: "StatusWarningWeaker", icon: "alertTriangleFill" };
    case "success":
      return { color: "StatusSuccessWeaker", icon: "formCheckCircle" };
    case "info":
    default:
      return { color: "UiPrimaryWeaker", icon: "alertInfoFill" };
  }
}, Qn = (t) => t ? x : H, ea = ({
  ariaLabel: t,
  href: n,
  name: r,
  icon: o,
  isResponsive: a,
  selectedIcon: s,
  selected: c,
  color: m,
  active: _,
  badgeColor: b = "error-stronger",
  badgeNumber: l,
  rootTagName: v = "li",
  status: p,
  tooltipTitle: h,
  onPress: d,
  onKeyDown: E,
  ...g
}) => {
  const W = v, $ = Qn(n), i = s && c ? s : o, [f, M] = L(!1), [y, V] = L(null);
  S(() => () => {
    y && clearTimeout(y);
  }, [y]);
  const Y = () => {
    M(!0), y && clearTimeout(y), V(setTimeout(() => M(!1), 1500));
  }, u = () => {
    y && clearTimeout(y), M(!1);
  }, C = () => {
    M(!0), y && clearTimeout(y), V(setTimeout(() => M(!1), 1500));
  }, ye = () => {
    y && clearTimeout(y), M(!1);
  };
  return /* @__PURE__ */ e.createElement(W, { "aria-current": c, className: G.sideBarItem }, /* @__PURE__ */ e.createElement(
    w,
    {
      content: h,
      isOpen: f,
      placement: "right",
      offset: 5
    },
    /* @__PURE__ */ e.createElement(
      $,
      {
        "aria-label": t || r,
        "data-testid": "buttonTab",
        "data-selected": c,
        "data-responsive": a,
        "data-custom-component": "product-nav-sidenavitem",
        className: G.buttonStyles,
        href: n,
        onPress: d,
        onKeyDown: E,
        onFocus: Y,
        onBlur: u,
        onHoverStart: C,
        onHoverEnd: ye,
        ...g
      },
      /* @__PURE__ */ e.createElement(
        I,
        {
          "aria-hidden": !0,
          "aria-label": i,
          name: i,
          color: m,
          size: 20,
          isBlock: !0
        }
      ),
      l && p === void 0 ? /* @__PURE__ */ e.createElement("div", { className: G.badgeStyles, "data-responsive": a }, /* @__PURE__ */ e.createElement(Be, { variant: b }, l.toString())) : null,
      p && /* @__PURE__ */ e.createElement(
        "div",
        {
          className: G.statusIconStyles,
          "data-responsive": a
        },
        /* @__PURE__ */ e.createElement(
          I,
          {
            "aria-hidden": !0,
            "aria-label": p,
            name: _e(p).icon,
            color: _e(p).color,
            size: 18,
            isBlock: !0
          }
        )
      )
    )
  ));
}, ta = "_root_1dudf_1", na = "_sideBar_1dudf_5", aa = "_bottomElement_1dudf_21", ra = "_sideBarCorner_1dudf_26", oa = "_sideBarRightCorner_1dudf_47", D = {
  root: ta,
  sideBar: na,
  bottomElement: aa,
  sideBarCorner: ra,
  sideBarRightCorner: oa
}, ca = ({
  backgroundColor: t = ae.GrayWarm9,
  bottomElement: n,
  bottomElementPositon: r = "5px",
  boxShadow: o = ae.PrimeWhite,
  children: a,
  isResponsive: s = !1,
  zIndex: c
}) => /* @__PURE__ */ e.createElement("div", { className: D.root }, /* @__PURE__ */ e.createElement(
  "ul",
  {
    className: D.sideBar,
    style: {
      "--backgroundColor": t,
      "--zIndex": c,
      "--boxShadow": o
    },
    "data-custom-component": "product-nav-sidenav",
    "data-responsive": s
  },
  a
), n && /* @__PURE__ */ e.createElement(
  "div",
  {
    className: D.bottomElement,
    "data-responsive": s,
    style: {
      "--bottomElementPosition": r,
      "--zIndex": c
    }
  },
  n
), /* @__PURE__ */ e.createElement(
  "div",
  {
    className: D.sideBarCorner,
    "data-responsive": s,
    style: {
      "--backgroundColor": t,
      "--zIndex": c
    }
  }
), /* @__PURE__ */ e.createElement(
  "div",
  {
    className: D.sideBarRightCorner,
    "data-responsive": s,
    style: {
      "--backgroundColor": t,
      "--zIndex": c
    }
  }
));
ca.SideBarItem = ea;
const sa = "_taglabel_8ladd_1", la = {
  taglabel: sa
}, $a = ({
  background: t = "var(--zds-gray-warm-8, #574e4c)",
  color: n = "var(--zds-text-inverted, #fffdf9)",
  children: r
}) => /* @__PURE__ */ e.createElement(
  "span",
  {
    className: la.taglabel,
    style: {
      "--taglabel-baseBackgroundColor": t,
      "--taglabel-baseColor": n
    },
    "data-custom-component": "product-nav-TagLabel"
  },
  r
), ia = "_upgradeCta_a61fc_1", ua = "_upgradeCtaPlanName_a61fc_7", ma = "_upgradeCtaLink_a61fc_23", te = {
  upgradeCta: ia,
  upgradeCtaPlanName: ua,
  upgradeCtaLink: ma
}, ka = ({
  upgradeHref: t,
  target: n = "_blank",
  planName: r,
  planLinkText: o = "View plans",
  productName: a
}) => r ? /* @__PURE__ */ e.createElement(
  "div",
  {
    className: te.upgradeCta,
    "data-custom-component": "product-nav-UpgradeCTA"
  },
  /* @__PURE__ */ e.createElement("span", { className: te.upgradeCtaPlanName }, r),
  /* @__PURE__ */ e.createElement(
    x,
    {
      className: te.upgradeCtaLink,
      href: `${t}?utm_source=${a}&utm_medium=builder-frame`,
      target: n,
      rel: n === "_blank" ? "noopener noreferrer" : void 0
    },
    o
  )
) : null, da = "_zoomWrapper_fxjmj_1", pa = {
  zoomWrapper: da
}, _a = "_form_pgv7a_1", fa = "_input_pgv7a_9", fe = {
  form: _a,
  input: fa
}, ba = oe((t, n) => {
  const { label: r } = t, o = P(null);
  S(() => {
    typeof n == "function" ? n(o.current) : n && (n.current = o.current);
  }, [n]);
  const { labelProps: a, inputProps: s } = Ee(t, o);
  return /* @__PURE__ */ e.createElement("form", { className: fe.form, onSubmit: t.onSubmit }, /* @__PURE__ */ e.createElement(he, null, /* @__PURE__ */ e.createElement("label", { ...a, htmlFor: "zoom-control" }, r)), /* @__PURE__ */ e.createElement(
    "input",
    {
      ...s,
      ref: o,
      className: fe.input,
      id: "zoom-control",
      name: "zoom-control"
    }
  ));
}), be = (t) => t.id !== void 0, Ha = ({
  disabledKeys: t = [],
  menuItems: n = [],
  minZoom: r = 25,
  maxZoom: o = 200,
  onUpdateZoom: a,
  ...s
}) => {
  const { label: c, ...m } = s, [_, b] = L(!1), [l, v] = L(s.label), p = P(null), h = P(null);
  S(() => {
    v(s.label);
  }, [s.label]);
  const d = () => {
    b(!0), setTimeout(() => {
      var i, f;
      (i = p.current) == null || i.focus(), (f = p.current) == null || f.select();
    }, 0);
  }, E = (i) => {
    v(`${i}%`), a && a(i), b(!1), setTimeout(() => {
      var f;
      (f = h.current) == null || f.focus();
    }, 0);
  }, g = {
    custom: d,
    ...n.reduce((i, f) => be(f) ? { ...i, [f.id]: f.action } : i, {})
  }, W = (i) => {
    const f = g[i];
    f && f();
  }, $ = (i) => {
    const f = Number(i), M = Math.min(Math.max(f, r), o);
    E(M);
  };
  return /* @__PURE__ */ e.createElement("div", { className: pa.zoomWrapper }, _ ? /* @__PURE__ */ e.createElement(
    ba,
    {
      type: "number",
      label: "Zoom level",
      ref: p,
      value: Number(l.includes("%") ? l.replace("%", "") : l),
      onBlur: (i) => {
        $(i.target.value);
      },
      onChange: (i) => v(i),
      onSubmit: () => $(l)
    }
  ) : /* @__PURE__ */ e.createElement(
    N,
    {
      ref: h,
      iconAfter: "arrowSmallDown",
      label: l,
      onAction: W,
      disabledKeys: t,
      placement: "bottom",
      size: "small",
      ...m
    },
    a && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(N.Section, { label: "Custom zoom" }, /* @__PURE__ */ e.createElement(N.Item, { id: "custom", key: "custom" }, "Custom zoom")), /* @__PURE__ */ e.createElement(N.Separator, { key: "Custom zoom" })),
    n.map(
      (i, f) => e.isValidElement(i) ? e.cloneElement(i, { key: f }) : be(i) ? /* @__PURE__ */ e.createElement(
        N.Item,
        {
          id: i.id,
          key: i.id,
          href: i.href,
          variant: i.variant
        },
        i.icons ? /* @__PURE__ */ e.createElement(
          hn,
          {
            textValue: i.label,
            icons: i.icons
          }
        ) : i.label
      ) : null
    )
  ));
}, Ea = "27bc4b69", za = `https://design-system-css.zapier.com/product-nav/${Ea}/style.css`;
export {
  Ma as AssetControl,
  Aa as AvatarStack,
  za as BUILDER_FRAME_STYLESHEET,
  Ba as BuilderFrameButton,
  Ue as BuilderFrameIconButton,
  La as BuilderFrameLayout,
  Sa as Drawer,
  N as DropdownMenu,
  Ge as GenericPopoverBox,
  Kt as Grid,
  Wa as GridItem,
  Pa as Header,
  wa as HeaderLayout,
  hn as IconMenuItemContent,
  jn as ProductHub,
  Ta as ProductListButton,
  ca as SideBar,
  ea as SideBarItem,
  $a as TagLabel,
  X as ToolbarButton,
  ka as UpgradeCTA,
  Ha as ZoomControl
};
